import moment from 'moment'
export default {
  name: 'yearlyCalendar',
  props: {
    yearOptionsProp: {
      type: Array,
      default () { return [] }
    },
    selectedYearProp: {
      type: String,
      default () { return moment().format('YYYY') }
    },
    selectedMonthProp: {
      type: String,
      default () { return moment().format('MM') }
    },
    calendarStyleProp: {
      type: String,
      default () { return 'allMonthsInline' }
    },
    calendarDataProp: {
      default () { return [] }
    }
  },
  watch: {
    selectedYearProp (newVal) {
      this.selectedYear = newVal
    },
    selectedMonthProp (newVal) {
      this.selectedMonth = newVal
    },
    calendarStyleProp (newVal) {
      this.calendarStyle = newVal
    },
    yearOptionsProp: {
      handler (newVal) {
        this.yearOptions = newVal
      },
      deep: true
    },
    calendarDataProp: {
      handler (newVal) {
        this.calendarData = newVal
      },
      deep: true
    }
  },
  data () {
    return {
      yearlyCalendar: null,
      selectedYear: this.selectedYearProp,
      selectedMonth: this.selectedMonthProp,
      calendarStyle: this.calendarStyleProp,
      yearOptions: this.yearOptionsProp,
      calendarData: this.calendarDataProp
    }
  },
  methods: {
    emitEvent (action, data) {
      if (action !== null || action.length > 0) {
        this.$emit('yearly-calendar-change', { action, payload: { data } })
      }
    },
    createYearlyCalendarData () {
      // eslint-disable-next-line prefer-const
      let yearlyCalendar = {
        year: this.selectedYear,
        months: []
      }

      // Set moment year and first month of the specific year
      const momentFromYear = moment().year(yearlyCalendar.year).set({ hour: '0', minute: '0', second: '0' })
      const momentStartOfYear = momentFromYear.clone().startOf('year')

      // Create all months for this specific year
      for (let countMonth = 0; countMonth <= 11; countMonth++) {
        const getMonth = momentStartOfYear.clone().add(countMonth, 'M')

        const monthDetails = {
          id: getMonth.clone().format('MM'),
          dateStartMonthFormat: getMonth.clone().format('YYYY-MM-DD'),
          yearFormat: getMonth.clone().format('YYYY'),
          yearMonthFormat: getMonth.clone().format('YYYY-MM'),
          title: {
            short: this.$t('el.datepicker.months.' + getMonth.clone().format('MMM').toLowerCase())
          },
          dates: []
        }

        yearlyCalendar.months.push(monthDetails)
      }
      this.yearlyCalendar = yearlyCalendar
    },
    /**
     * Handle Month selection in the calendar
     * @param {Object} month
     */
    handleMonthClick (month) {
      if (this.selectedMonth !== month.id) {
        this.selectedMonth = month
      } else {
        this.selectedMonth = null
      }

      const eventData = (this.selectedMonth !== null) ? this.selectedMonth : null
      this.emitEvent('CALENDAR_MONTH_SELECTED', eventData)
    },
    /**
     * Handle year selection in the calendar
     * @param {String} year
     */
    handleYearClick (year) {
      this.selectedYear = year
      this.createYearlyCalendarData()
      this.emitEvent('CALENDAR_YEAR_SELECTED', year)
    }
  },
  mounted () {
    this.createYearlyCalendarData()
  }
}
